<script setup>
    import { ref, computed, onMounted, watch } from 'vue'
    import { useRoute } from 'vue-router'

    import store from '../store'

    const route = useRoute()

    const selectedLang = ref({})
    const langValue = computed(() => {
        return Object.entries(store.state.langValues.language).map(([value, title]) => ({ value, title }))
    })

    const currentLang = computed(() => {
        return store.state.lang
    })
 
    watch(() => currentLang.value, (n) => {
        selectedLang.value = langValue.value.find(el => el.value == n).value
    })

    watch(() => selectedLang.value, (n) => {

        if (n != store.state.lang) {
            window.location.href = new URL(window.location.href).origin + process.env.BASE_URL + '?lang=' + n
        }
    })

    function goHome() {
        window.open('https://www.twitch.tv/directory/category/grand-chase-classic', '_blank')
    }

    const snsItems = [
        {
            title: 'Discord',
            icon: 'fa-brands fa-discord',
            link:'https://discord.com/invite/grandchaseclassic'
        },
        {
            title: 'Instagram',
            icon: 'fa-brands fa-instagram',
            link: 'https://www.instagram.com/gcclassic_official/'
        },
        {
            title: 'Facebook',
            icon: 'fa-brands fa-square-facebook',
            link: 'https://www.facebook.com/GrandChaseClassic'
        }, {
            title: 'Youtube',
            icon: 'fa-brands fa-youtube',
            link: 'https://www.youtube.com/watch?v=HRySxF4731I'
        }
        , {
            title: 'Twitter',
            icon: 'fa-brands fa-x-twitter',
            link: 'https://x.com/GrandChase'
        }
    ]

</script>

<template>
    <header class="header">
        <div class="inner">
            <div class="logo">
                <img src="images/gcpc-logo.png" />
                
            </div>
            <div class="d-flex align-center">
                <div >
                    <v-select class="selectBox"
                              v-model="selectedLang"
                              :items="langValue"
                              item-title="title"
                              item-value="value"
                              variant="outlined"
                              density="compact"
                              hide-details="auto"></v-select>
                </div>
                <div>
                    <v-btn fab
                           :min-height="$vuetify.display.smAndDown ? '40' : '50'"
                           :size="$vuetify.display.smAndDown ? 'x-small' : 'small'"
                           variant="text"
                           @click="goHome">
                        <v-icon class="twitchIcon">
                            fa-brands fa-twitch
                        </v-icon>
                        <img src="images/icon-bg.png" />
                    </v-btn>
          
                    <v-menu transition="slide-y-transition">
                        <template v-slot:activator="{ props }">
                            <v-btn fab
                                   class="pl-0"
                                   :min-height="$vuetify.display.smAndDown ? '40' : '50'"
                                   :size="$vuetify.display.smAndDown ? 'x-small' : 'small'"
                                   v-bind="props"
                                   variant="text">
                                 <img src="images/share-icon.png" />
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item v-for="(item, i) in snsItems"
                                         :key="i"
                                         :value="i">
                                <v-list-item-title>
                                    <v-icon size="small"
                                            class="mr-4">
                                        {{item.icon}}
                                    </v-icon>
                                    {{ item.title }} 
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
            </div>
        </div>
    </header>

</template>

<style lang="scss">
    .twitchIcon {
        position: absolute;
        color: #d1a2a7;
        font-size: 20px;
        top:50%;
        left: 50%;
        transform:translate(-50%,-50%)
    }
    .header {
        max-width: 2560px;
        padding: 5px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 70px;
        width: 100%;
        position: fixed;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        z-index: 2500;

        .inner {
            width: 100%;
            height: 100%;
            max-width: 1920px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 0 auto;

            .logo {
                height: 100%;

                img {
                    height: 100%;
                }
            }

            img {
                width: auto;
            }

            > div {
                height: 100%;
            }

            .selectBox {
                background: #610b0c;
                box-sizing: border-box;
                color: #fff;
                outline: none;
            }
        }

        @media all and (max-width: 640px) {
            .inner {
                .logo {
                    height: 40px;

                    img {
                    }
                }

                button {
                    img {
                        height: 40px;
                    }
                }

                .selectBox {
                    span {
                        font-size: 12px !important;
                    }
                }
            }
        }
    }
    .menuZindex {
        z-index: 2600 !important; 
    }
</style>